<template>
  <li class="post-form-media-item">
    <v-icon small v-handle-directive class="slicksort-handler">grain</v-icon>
    <!-- <v-icon v-handle-directive class="slicksort-handler">import_export</v-icon> -->

    <component
      :is="componentsMap[item.type]"
      :media.sync="item"
      class="media-item"
    ></component>

    <v-btn flat icon class="remove" @click="$emit('remove')">
      <v-icon>delete</v-icon>
    </v-btn>
  </li>
</template>

<script>

import { ElementMixin, HandleDirective } from 'vue-slicksort';
import PostFormMediaVideoItem from '@/components/PostFormMediaVideoItem';
import PostFormMediaAudioItem from '@/components/PostFormMediaAudioItem';
import PostFormMediaImageItem from '@/components/PostFormMediaImageItem';

const componentsMap = {
  video: PostFormMediaVideoItem,
  audio: PostFormMediaAudioItem,
  image: PostFormMediaImageItem,
};

export default {
  name: 'PostFormMediaItem',
  components: {
    PostFormMediaVideoItem,
    PostFormMediaImageItem,
  },
  directives: {
    HandleDirective,
  },
  mixins: [ElementMixin],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      componentsMap,
    };
  },
};

</script>

<style scoped>

.post-form-media-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 5px;;
}

.media-item {
  flex: 1;
}

.slicksort-handler {
  cursor: row-resize;
  margin-right: 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/PostFormMediaItem.vue